<template>
  <main :class="['v-view-primary',
    $store.getters.getAcademyData.persona === undefined
      ? 'v-view-primary-upgrade' : '']">
    <OrganismTheHeader/>
    <OrganismUpdatingLicence/>
  </main>
</template>

<script>
export default {
  name: 'UpdatingLicence',

  components: {
    OrganismUpdatingLicence: () => import('@/components/organisms/OrganismUpdatingLicence')
  }
}
</script>
